import { render, staticRenderFns } from "./_PriceConfirm.vue?vue&type=template&id=7d70002a"
import script from "./_PriceConfirm.vue?vue&type=script&lang=js"
export * from "./_PriceConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports